import { render } from "./AddRoomsSection.vue?vue&type=template&id=2cc00706"
import script from "./AddRoomsSection.vue?vue&type=script&lang=js"
export * from "./AddRoomsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__